import { styled } from 'styled-components';

const ApplyFooter = styled.footer`
	margin-top: auto;
	margin-bottom: 30px;
	width: 100%;
`;

export default ApplyFooter;
